import { Controller } from '@hotwired/stimulus';

// #2038 Step 1: 給与項目の copy/no-copy AI 判定の生成とポーリング表示(管理者向け)。
// ai_comment_controller と同型。
export default class extends Controller {
  static targets = ['body', 'footer', 'button'];
  static values = {
    showUrl: String,
    createUrl: String,
    pending: Boolean,
  };

  connect() {
    if (this.pendingValue) {
      this.disableButton();
      this.startPolling();
    }
  }

  create(event) {
    event.preventDefault();
    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content;

    fetch(this.createUrlValue, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-CSRF-Token': csrfToken },
    })
      .then((response) => response.json())
      .then(() => {
        this.showLoading();
        this.startPolling();
      });
  }

  showLoading() {
    this.bodyTarget.innerHTML = `
      <div class="text-center py-3">
        <div class="spinner-border spinner-border-sm text-info me-2" role="status"></div>
        <span>判定を生成中...</span>
      </div>`;
    this.disableButton();
  }

  disableButton() {
    if (this.hasButtonTarget) this.buttonTarget.disabled = true;
  }

  enableButton() {
    if (this.hasButtonTarget) this.buttonTarget.disabled = false;
  }

  startPolling() {
    this.pollTimer = setInterval(() => {
      fetch(this.showUrlValue, { headers: { Accept: 'application/json' } })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 'completed') {
            this.stopPolling();
            this.renderItems(data.items || []);
          } else if (data.status === 'failed') {
            this.stopPolling();
            this.renderFailed(data);
          }
        });
    }, 3000);
  }

  stopPolling() {
    if (this.pollTimer) {
      clearInterval(this.pollTimer);
      this.pollTimer = null;
    }
  }

  disconnect() {
    this.stopPolling();
  }

  renderItems(items) {
    if (!items.length) {
      this.bodyTarget.innerHTML = '<p class="text-muted">判定結果がありません。</p>';
      this.enableButton();
      return;
    }
    const rows = items
      .map((item) => {
        const badge = item.copy
          ? '<span class="badge text-bg-success">🔄 コピー</span>'
          : '<span class="badge text-bg-secondary">🚫 コピーしない</span>';
        const reason = item.reason
          ? `<small class="text-muted">${this.escapeHtml(item.reason)}</small>`
          : '';
        return `
          <li class="list-group-item d-flex justify-content-between align-items-start">
            <div>
              <div class="fw-bold">${this.escapeHtml(item.name || '')}</div>
              ${reason}
            </div>
            ${badge}
          </li>`;
      })
      .join('');
    this.bodyTarget.innerHTML = `<ul class="list-group list-group-flush">${rows}</ul>`;
    this.enableButton();
  }

  renderFailed(data) {
    const msg = this.escapeHtml(data.error || '不明なエラー');
    this.bodyTarget.innerHTML = `<p class="text-danger">判定の生成に失敗しました: ${msg}</p>`;
    this.enableButton();
  }

  escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }
}
